import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registrarServiceWorker } from './registrarSW';
import './services/analytics'; // PostHog (se auto-difiere internamente)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ── Telemetría diferida — fuera del bundle crítico ──────────────────────────
// Sentry, Vercel Analytics y Speed Insights NO son necesarios para el primer
// render. Los cargamos con dynamic import cuando el navegador está libre, así
// salen del main bundle y la app pinta más rápido en móvil (clave para
// Colombia). Si la red está lenta, simplemente cargan un poco después.
function cargarTelemetria() {
  // Sentry — solo si hay DSN configurado
  if (process.env.REACT_APP_SENTRY_DSN) {
    import('@sentry/react')
      .then((Sentry) => {
        Sentry.init({
          dsn:              process.env.REACT_APP_SENTRY_DSN,
          environment:      process.env.NODE_ENV,
          tracesSampleRate: 0.1,
          integrations: [
            Sentry.browserTracingIntegration(),
            // Session Replay: graba qué hizo el usuario antes de un error.
            Sentry.replayIntegration(),
          ],
          // 10% de las sesiones normales; 100% de las que tuvieron un error.
          replaysSessionSampleRate: 0.1,
          replaysOnErrorSampleRate: 1.0,
        });
      })
      .catch(() => {});
  }

  // Vercel Analytics + Speed Insights — montados en un nodo aparte para no
  // re-renderizar <App/>. Usan la API imperativa (inject) en vez de los
  // componentes React, que es justo para esto.
  import('@vercel/analytics').then((m) => m.inject?.()).catch(() => {});
  import('@vercel/speed-insights').then((m) => m.injectSpeedInsights?.()).catch(() => {});
}

if (typeof window !== 'undefined') {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(cargarTelemetria, { timeout: 5000 });
  } else {
    setTimeout(cargarTelemetria, 3000);
  }
}

// PWA / modo offline — la app abre aunque no haya internet (ver public/sw.js).
registrarServiceWorker();

reportWebVitals();
